// extracted by mini-css-extract-plugin
export default {"wrapper":"TinyEditor_wrapper__z8rbE"};